import React from 'react';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

const Privacypolicy = () => {
    return (
        <>
            <Container className="container">
                <Typography className="headerStyle" variant="h3" gutterBottom component="div" style={{textAlign: 'left', marginTop: '16px'}}>
                    Privacy Policy
                </Typography>


            </Container>
        </>
    );
}

export default Privacypolicy;
